export const consulting = {
  id: 'consulting',
  name: 'Management Consulting',
  sectionOrder: ['summary', 'experience', 'projects', 'education', 'skills'],
  defaultLayout: 'single-column',
  recommendedTemplates: ['harvard-classic', 'product-consulting'],
  components: {
    experience: 'experience-classic',
    skills: 'skills-simple-list',
    header: 'header-classic'
  }
};
export default consulting;
